"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Togglebox = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var Togglebox = /** @class */ (function (_super) {
    __extends(Togglebox, _super);
    function Togglebox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickHandler = function (e) {
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.value, e.currentTarget.checked);
                e.currentTarget.focus;
            }
        };
        _this.getControl = function (control, controlProps) {
            if (control === 'checkbox')
                return react_1.default.createElement(__1.Checkbox, __assign({}, controlProps));
            if (control === 'radio')
                return react_1.default.createElement(__1.Radio, __assign({}, controlProps));
            if (control === 'toggleSwitch') {
                var error = controlProps.error, props = __rest(controlProps, ["error"]);
                return react_1.default.createElement(__1.ToggleSwitch, __assign({}, props));
            }
        };
        _this.getTitle = function () {
            if (_this.props.title === undefined || _this.props.title === '')
                return;
            return react_1.default.createElement("div", { className: "Togglebox__title" }, _this.props.title);
        };
        _this.getLabel = function () {
            if (_this.props.label === undefined || _this.props.label === '')
                return;
            return react_1.default.createElement("div", { className: "Togglebox__label" }, _this.props.label);
        };
        return _this;
    }
    Togglebox.prototype.render = function () {
        var _a;
        var _b = this.props, checked = _b.checked, className = _b.className, _c = _b.control, control = _c === void 0 ? 'checkbox' : _c, _d = _b.controlAlign, controlAlign = _d === void 0 ? 'center' : _d, disabled = _b.disabled, error = _b.error, id = _b.id, label = _b.label, name = _b.name, onChange = _b.onChange, onClick = _b.onClick, title = _b.title, value = _b.value, props = __rest(_b, ["checked", "className", "control", "controlAlign", "disabled", "error", "id", "label", "name", "onChange", "onClick", "title", "value"]);
        var toggleboxProps = __assign({ checked: checked, disabled: disabled, error: error }, props);
        var uiProps = { checked: checked, disabled: disabled, error: error, name: name, value: value, id: id };
        var ToggleboxClasses = classnames_1.default('Togglebox', className, (_a = {},
            _a["Togglebox--" + control] = control,
            _a['Togglebox--controlTop'] = controlAlign === 'top',
            _a));
        var ContentClasses = classnames_1.default('Togglebox__content', {
            'Togglebox__content--title': title,
        });
        return (react_1.default.createElement(__1.Card, __assign({ active: checked, className: ToggleboxClasses, onClick: this.onClickHandler, raised: checked, sharp: true, thin: true }, toggleboxProps),
            react_1.default.createElement(__1.Card.Section, null,
                react_1.default.createElement("span", { className: ContentClasses },
                    react_1.default.createElement("span", { className: "Togglebox__control" }, this.getControl(control, __assign({}, uiProps))),
                    react_1.default.createElement("span", { className: "Togglebox__children" },
                        this.getTitle(),
                        this.getLabel())))));
    };
    return Togglebox;
}(react_1.Component));
exports.Togglebox = Togglebox;
//# sourceMappingURL=Togglebox.js.map